<template>
  <div class="tag-selection">
    <div class="button-group">
      <el-button v-if="!showTagSelector" type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="wantShowTagSelector = true">{{
        $t('receiving_object')
      }}</el-button>
    </div>
    <template v-if="showTagSelector && questionSite.questionList && questionSite.questionList.length > 0">
      <div class="question-menu-list">
        <div>
          <div class="q-menu-first">
            <ul>
              <li
                v-for="(qItem, index) in questionSite.questionList"
                :key="qItem.id"
                :class="{ active: levelOneIndex === index }"
                @click="setListByIndex(index)"
              >
                {{ qItem.aliasName }}
              </li>
            </ul>
          </div>
          <div class="q-menu-second" v-if="qSecondList.length > 0">
            <table class="bl-table bl-find-c-table">
              <tbody>
                <template v-if="hasLevelThree">
                  <tr v-for="qItem in qSecondList" :key="qItem.id">
                    <!-- bl-table-th -->
                    <td width="155" class="bl-table-head">{{ qItem.aliasName }}</td>
                    <td>
                      <div class="tag-col-list">
                        <div :ref="'tag-col-' + levelOneIndex">
                          <template v-if="questionSite.selectedType !== 'multiple'">
                            <el-radio-group
                              v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, qItem, questionSite.questionList[levelOneIndex])"
                            >
                              <el-radio
                                :label="item.id"
                                v-for="item in qItem.subAnswerList"
                                :key="item.id"
                                :disabled="selectDisable && !isInSelectedList(item.id)"
                                >{{ item.aliasName }}</el-radio
                              >
                            </el-radio-group>
                          </template>
                          <template v-else>
                            <el-checkbox-group
                              v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, qItem, questionSite.questionList[levelOneIndex])"
                            >
                              <el-checkbox
                                :label="item.id"
                                v-for="item in qItem.subAnswerList"
                                :key="item.id"
                                :disabled="(selectDisableList[item.questionId] || selectDisable) && !isInSelectedList(item.id)"
                                >{{ item.aliasName }}</el-checkbox
                              >
                            </el-checkbox-group>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td>
                      <div class="tag-col-list">
                        <div :ref="'tag-col-' + levelOneIndex">
                          <template v-if="questionSite.selectedType !== 'multiple'">
                            <el-radio-group
                              v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, questionSite.questionList[levelOneIndex])"
                            >
                              <el-radio
                                :label="item.id"
                                v-for="item in qSecondList"
                                :key="item.id"
                                :disabled="selectDisable && !isInSelectedList(item.id)"
                                >{{ item.aliasName }}</el-radio
                              >
                            </el-radio-group>
                          </template>
                          <template v-else>
                            <el-checkbox-group
                              v-model="checkList[levelOneIndex]"
                              @change="addSelectVal(levelOneIndex, questionSite.questionList[levelOneIndex])"
                            >
                              <el-checkbox
                                :label="item.id"
                                v-for="item in qSecondList"
                                :key="item.id"
                                :disabled="(selectDisableList[item.questionId] || selectDisable ) && !isInSelectedList(item.id)"
                                >{{ item.aliasName }}</el-checkbox
                              >
                            </el-checkbox-group>
                          </template>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="bl-find-condition__selected" v-if="showTagContainer()">
        <template v-for="item in selectedList">
          <label v-for="(lItem, index) in item" :key="lItem.id"
            ><span>{{ lItem.names[0] }}：</span
            ><span class="last-value">{{ lItem.names.length > 2 ? lItem.names[1] + ' / ' + lItem.name : lItem.name }}</span
            ><i class="el-icon-close" @click="cClose(lItem, index)"></i
          ></label>
        </template>
      </div>
      <template v-if="showTips && questionSite.selectedType === 'multiple'">
        <div class="font-size-12 color-black-45" v-if="selectDisableList[curQuestion['id']]">
          {{$t('note2')}}
          {{language == 'en' ? ($t('noteText[0]') + limitedAmountList[curQuestion['id']] + ' ' + curQuestion['aliasName'] + $t('noteText[1]')) : (curQuestion['aliasName'] + $t('noteText[0]') + limitedAmountList[curQuestion['id']] + $t('noteText[1]'))}}
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { questionSite } from '@/api/opportunity'
export default {
  props: {
    // 获取类型： PRODUCT_PUBLISH / PERSON_PUBLISH
    types: {
      type: String,
      default: 'PERSON_PUBLISH'
    },
    limitedTagAmount: {
      type: Number,
      default: -1
    },
    // 不要与便签限制总数（limitedTagAmount）同时设置
    // 只针对多选
    limitedAmountList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    answerList: {
      type: Array,
      default: () => {
        return []
      }
    },
    showTips: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    wantShowTagSelector: false,
    isQuestionListLoaded: false,
    selectedList: {},
    questionSite: {},
    levelOneIndex: 0,
    qSecondList: [],
    hasLevelThree: false, // 是否有三级
    checkList: [],
    selectDisable: false,
    selectDisableList: {},
    tipsList: {},
    curQuestion: {}
  }),
  computed: {
    ...mapGetters(['subjectType', 'language']),
    showTagSelector() {
      if(this.wantShowTagSelector) {
        return true
      }
      return this.answerList.length > 0
    }
  },
  mounted() {
    let params = {
      showType: this.types
    }
    if (this.subjectType === 'VISITOR') {
      params.showType = 'ACTOR_PUBLISH'
    }
    questionSite(params)
      .then(res => {
        this.questionSite = res.data.data
        if (this.questionSite.questionList && this.questionSite.questionList.length > 0) {
          this.setListByIndex(0)
          this.questionSite.questionList.forEach((item, index) => {
            if (this.questionSite.selectedType === 'multiple') {
              this.$set(this.checkList, index, [])
            } else {
              this.$set(this.checkList, index, '')
            }
            this.tipsList[item.id] = item.aliasName
          })
          this.isQuestionListLoaded = true
        }
      })
      .finally(() => {})
  },

  watch: {
    answerList: {
      handler(val) {
        if(val.length > 0 && this.isQuestionListLoaded) {
          this.renderSelectedTag(val)
        }
      }
    },
    isQuestionListLoaded: {
      handler(val) {
        if(val && this.answerList.length > 0) {
          this.renderSelectedTag(this.answerList)
        }
      }
    },
    selectedList: {
      deep: true,
      handler(val) {
        this.limitedNum(val)
      }
    }
  },

  methods: {
    limitedNum(val) {
      // 只针对多选
      if (this.questionSite.selectedType != 'multiple') return

      let curQuestionId = this.questionSite.questionList[this.levelOneIndex]['id']
      let amount = 0
      this.curQuestion = this.questionSite.questionList[this.levelOneIndex]
      Object.keys(val).forEach(item => {
        amount += val[item].length
      })

      /**
       * 是否存在类别限制列表
       */
      if (JSON.stringify(this.limitedAmountList) == '{}') {
        this.$set(this.selectDisableList, curQuestionId, false)
      } else {
        /**
         * 存在类别限制列表
         * 是否存在当前的类别的选中个数限制
         */
        if (this.limitedAmountList[curQuestionId]) {
          /**
           * 存在当前的类别的选中个数限制
           * 是否超过当前类别的选中个数限制
           */
          if (val[curQuestionId] && val[curQuestionId].length >= this.limitedAmountList[curQuestionId]) {
            this.$set(this.selectDisableList, curQuestionId, true)
          } else {
            this.$set(this.selectDisableList, curQuestionId, false)
          }
        } else {
          this.$set(this.selectDisableList, curQuestionId, false)
        }
      }

      if (this.limitedTagAmount !== -1 && amount >= this.limitedTagAmount) {
        this.selectDisable = true
      }

      if (this.limitedTagAmount !== -1 && amount < this.limitedTagAmount) {
        this.selectDisable = false
      }
    },

    getTipsList() {
      return this.tipsList
    },

    renderSelectedTag(answerList) {
      answerList.forEach((item, index) => {
        // 获取答案所在一级索引
        // NOTICE: Array.prototype.findIndex does not support IE
        let levelOneIndex = this.questionSite.questionList.findIndex(_item => _item.id === item.id)
        if (levelOneIndex < 0) return
        if(index === 0 ) {
          this.setListByIndex(levelOneIndex)
        }
        let qSecondList = this.questionSite.questionList[levelOneIndex].answerList
        // 单选数据结构
        if(this.questionSite.selectedType === 'multiple') {
          item.answerList.forEach(mulItem => {
            this.checkList[levelOneIndex].push(mulItem.id)
          })
        } else {
          this.checkList[levelOneIndex] = item.answerList[0].id
        }

        // let levelTwoData = ''
        // 是否为三级答案
        let hasLevelThree = false
        for (let i = 0; i < qSecondList.length; i++) {
          if (!qSecondList[i].leaf) {
            hasLevelThree = true
            break
          }
        }

        if(hasLevelThree) {
          // 获取二级答案数据, 若有三级，API不返回二级答案
          let levelTwoDataArr = []
          qSecondList.forEach(levelTwoItem => {
            // 已选答案列表
            item.answerList.forEach(answerItem => {
              if(answerItem.parentAnswerId === levelTwoItem.id) {
                levelTwoDataArr.push(levelTwoItem)
              }
            })
          })
                
          // set selectedList
          levelTwoDataArr.forEach(qItem => {
            this.addSelectVal(levelOneIndex, qItem, this.questionSite.questionList[levelOneIndex])
          })
        } else {
          // set selectedList
          this.addSelectVal(levelOneIndex,  this.questionSite.questionList[levelOneIndex])
        }

      })
    },

    showTagContainer() {
      let boolean = false
      Object.keys(this.selectedList).forEach(item => {
        if (this.selectedList[item].length > 0) {
          boolean = true
        }
      })
      return boolean
    },

    setListByIndex(index) {
      let item = this.questionSite.questionList[index]
      this.levelOneIndex = index
      this.curQuestion = item
      // has level 3 data
      if (item.answerList && item.answerList.length > 0) {
        this.qSecondList = this.questionSite.questionList[index].answerList
      } else {
        this.qSecondList = []
      }
      this.hasLevelThree = false

      for (let i = 0; i < this.qSecondList.length; i++) {
        if (!this.qSecondList[i].leaf) {
          this.hasLevelThree = true
          break
        }
      }

      // used in addSelectVal
      if (this.hasLevelThree) {
        this.qSecondList.forEach(item => {
          let _item = JSON.parse(JSON.stringify(item))
          if (item.leaf) {
            delete _item.subAnswerList
            item.leaf = false
            item.answerList = [_item]
          } else {
            item.answerList = _item.subAnswerList
          }
        })
      }

      this.limitedNum(this.selectedList)
    },

    // get getQuestionList, used outside the componnent
    getQuestionList() {
      let questionList = []
      for (var k in this.selectedList) {
        let data = {
          questionId: k,
          answerIds: [],
          tagNames: []
        }
        this.selectedList[k].forEach(item => {
          data.answerIds.push(item.id)
          data.tagNames.push(item.name)
        })
        if (data.answerIds.length > 0) {
          questionList.push(data)
        }
      }
      return questionList
    },

    addSelectVal(index, data, data2) {
      let pId = data.questionId || data.id
      let names = []
      let checkedArray = this.checkList[index]
      if (data2) {
        names.push(data2.aliasName)
      }
      names.push(data.aliasName)
      if (!this.selectedList[pId]) {
        this.$set(this.selectedList, pId, [])
      }

      if (this.questionSite.selectedType !== 'multiple') {
        // 单选
        let a = this.selectedList[pId].filter(item => {
          return item.id === checkedArray
        })

        if (a.length > 0) return

        let c = data.answerList.filter(i => {
          return i.id === checkedArray
        })
        if (c.length == 0) return
        names.push(c[0].aliasName)
        this.$set(this.selectedList[pId], 0, {
          id: checkedArray,
          pId: pId,
          pIndex: index,
          names: names,
          name: c[0].aliasName,
          index: c[0].sequence - 1,
          data: c[0]
        })
      } else {
        // 多选
        if (checkedArray.length === 0) {
          this.selectedList[pId] = []
        } else {
          let sData = []
          this.selectedList[pId].forEach(item => {
            if (checkedArray.indexOf(item.id) > -1) {
              sData.push(item)
            }
          })
          this.selectedList[pId] = sData
        }

        checkedArray.forEach(item => {

          let b = this.selectedList[pId].filter(cItem => {
            return cItem.id === item
          })

          if (b.length === 0) {
            let c = data.answerList.filter(i => {
              return i.id === item
            })
            if (c.length == 0) return
            names.push(c[0].aliasName)
            this.selectedList[pId].push({
              id: item,
              pId: pId,
              pIndex: index,
              names: names,
              name: c[0].aliasName,
              index: c[0].sequence - 1,
              data: c[0]
            })
          }
          
        })
      }
    },
    cClose(data, index) {
      this.selectedList[data.pId].splice(index, 1)
      let cIndex = 0

      if (this.selectedList[data.pId].length === 0) {
        delete this.selectedList[data.pId]
      }

      if (this.questionSite.selectedType !== 'multiple') {
        this.checkList.some((item, index) => {
          if (item == data.id) {
            cIndex = index
            return
          }
        })
        this.checkList[cIndex] = ''
      } else {
        this.checkList[data.pIndex].some((item, index) => {
          if (item == data.id) {
            cIndex = index
            return
          }
        })
        this.checkList[data.pIndex].splice(cIndex, 1)
      }
    },

    isInSelectedList(id) {
      let boolean = false
      Object.keys(this.selectedList).forEach(item => {
        this.selectedList[item].forEach(tag => {
          if (tag.id === id) {
            boolean = true
          }
        })
      })
      return boolean
    }
  }
}
</script>
<style lang="stylus">
.tag-selection

  .question-menu-list
    position relative
    width 100%
    margin-bottom 18px
    .q-menu-second
      width 780px;
      width calc(100% - 106px)
    .q-menu-first,
    .q-menu-second
      height 350px
      overflow-y auto

    .q-menu-first
      width 106px
      float left
      border-right 1px solid $border-color-e5
      li
        text-align center
        min-height 42px
        line-height 22px
        padding 10px
        font-size 14px
        cursor pointer

        &:hover
          background $color-light9

        &.active
          background $color-main
          color $color-white

    .bl-table-head
      line-height 22px
      padding 10px
      vertical-align middle
      text-align center
      background-color $color-gray-fb


  .bl-find-condition__selected
    min-height 35px
    margin-bottom 18px
    // width 740px
    padding 8px
    border 1px solid $color-black-15
    border-radius 4px
    background: $color-white

    & > label
      display inline-block
      margin 8px
      padding 2px 10px
      background-color $color-light9
      line-height 20px
      font-size 14px

      .last-value
        margin-left 2px
        margin-right 14px
        color $color-main

      i
        cursor pointer
        transition all 0.5s

      &:hover
        i
          color $color-main
          transform rotate(180deg)
  .bl-find-c-table
    border none
    background $color-gray-fb
    td
      padding-top 6px
      padding-bottom 6px
      position relative
      border-top none
      border-right none
      border-width 6px
      border-color $color-gray-fb
      background-color $color-gray-f5
    tr:last-child
      td
        border-bottom none

    tr
      & >td:first-child
        border-left none

    .el-radio, .el-checkbox
      margin 5px 8px
      min-width 80px
</style>
